// extracted by mini-css-extract-plugin
export default {"timeColumn":"SystemNotifications_timeColumn__8cGuM","topRow":"SystemNotifications_topRow__pEw5U","bottomRow":"SystemNotifications_bottomRow__csQRo"};